/**
 * Copyright: IRT 2016-2017
 * 
 * Wrapper for the OIPF/HbbTV application manager.
 * 
 * @module AppMan
 */
	
var ks = false;
var app = false;
var val = 0;

var isActivated = false;

/**
 * Look for applications Application and Keyset objects.
 * 
 * Store initial value for keyset.
 */
function init () {
	try {
		var appMan = null;
		var objs = document.getElementsByTagName("object");
		for (var i=0; i<objs.length; i++) {
			if (objs.item(i).getAttribute("type") == "application/oipfApplicationManager") {
				appMan = objs.item(i);
				break;
			}
		}
		if (appMan) {
			app = appMan.getOwnerApplication(document);
		} else {
			app = oipfObjectFactory.createApplicationManagerObject().getOwnerApplication(document);
		}
		ks  = app.privateData.keyset;
		val = ks.value;
	} catch (e) {
		app = null;
		ks = null;
	}
}

/**
 * Show the browser window.
 */
function show() {
	if (app === false) init();
	try {
		app.show();
	} catch (e) {}
}

/**
 * Hide the browser window.
 */
function hide() {
	if (app === false) init();
	try {
		app.hide();
	} catch (e) {}
}

/**
 * Add a keyset constant(s) to the requested set of RC keys.
 * 
 * RC keys in HbbTV 2 are split into a set that is available all time and a set that is available only after activation of the app.
 * The app is activated when the user presses a key from the first set assuming the application had requested it.
 * 
 * Keys available all time: NAVIGATION, COLOUR.
 * 
 * Keys available after activation: NUMERICAL, VCR.
 * 
 * The keyset always shows which keys are available to the application, i.e. if the requested keyset is larger than the keys that are available, 
 * the resulting keyset contains only a subset of the requested one.
 * 
 * You can use the appman to add all required keys by your application before activation, 
 * however you have to use applyKeyset after your application got activated.
 * 
 * On terminals running HbbTV 1.x RC keys are always available to applications.
 * 
 * Note: Use this function carefully, request only keys you need and release keys with remKey when you don't need a key any longer.
 */
function addKey (keyValue) {
	if (ks === false) init();
	try {
		val = ks.value | keyValue;
		ks.setValue (val);
	} catch (e) {
	}
}

/**
 * Removes the value from the requested keyset, i.e. releases RC keys.
 * 
 * @param {*} keyValue keys to release, return to control of terminal
 */
function remKey (keyValue) {
	if (ks === false) init();
	val = (ks.value | keyValue) - keyValue;
	// make sure bits are set before removing them
	ks.setValue (val);
}

/**
 * @see addKey()
 * 
 * Re-applies requested keyset.
 */
function applyKeyset () {
	try {
		ks.setValue (val);
	} catch (e) {}
}

/**
 * Creates a new HbbTV application.
 * 
 *   Use dvb: URLs to launch another broadcast-related application
 *   Use https: URLs to launch a broadcast independent application
 * 
 * @param {*} url URL of application to run,
 */
function createApp (url) {
	if (app === false) init();
	try {
		/* Create a new application and add it to the application tree. Calling this method does not
			automatically show the newly-created application.
			This call is asynchronous and may return before the new application is fully loaded. An
			ApplicationLoaded event will be targeted at the Application object when the new
			application has fully loaded.
			If the application cannot be created, this method SHALL return null. 
		*/
		return app.createApplication(url, false);
	} catch (e) {}
}

/**
 * Calls destroyApplication.
 */
function killme() {
	if (app === false) init();
	try {
		/*
			Terminate the application, detach it from the application tree, and make any resources
			used available to other applications. When an application is terminated, any child
			applications shall also be terminated.
		*/
		app.destroyApplication();
	} catch (e) {
	}
}


/** 
 * An autostart broadcast related application is not activated by default (since 2.0).
 * It does not receive Numeric and VCR events if it is not activated.
 * 
 * It gets activated when it receives a colour or navigation key.
 */
function addActivationListener (l) {
	document.addEventListener("keydown", kel, false);
	function kel (e) {
		document.removeEventListener("keydown", kel, false);
		l();
	}
}


/**
 * For broadcast related applications returns the channel that carries the AIT that currently controls 
 * this application or null.
 */
function getCurrentChannel () {
	if (app === false) init();
	try {
		/*
			For a broadcast-related application, the value of the property contains the channel whose AIT is currently
			controlling the lifecycle of this application. If no channel is being presented, or if the application is not
			broadcast-related, the value of this property shall be null.
		*/
		return app.privateData.currentChannel;
	} catch (e) {
	}
	return null;
}

module.exports = {
	show : show,
	hide : hide,
	addKey : addKey,
	remKey : remKey,
	applyKeyset : applyKeyset,
	RED : 0x1,
	GREEN : 0x2,
	YELLOW : 0x4,
	BLUE : 0x8,
	COLOR: 0xF,
	NAVIGATION : 0x10,
	VCR: 0x20,
	NUMERIC : 0x100,
	NONE : 0x0,
	ALL : 0x13F,

	createApp : createApp,
	killme : killme,

	getCurrentChannel : getCurrentChannel,

	addActivationListener : addActivationListener
};
